<script setup lang="ts">
import { Motion } from 'motion/vue'
const { company } = useCompany()

const pixelGridLg = [
  '                                    ',
  '  1111111111111111111111111111111111111   ',
  ' 1111111111111111111111121111111111111    ',
  '  1111111112211111111122121111111111111   ',
  '   111111111111      1111111111111111111  ',
  '   1111111111111       111111122111111111 ',
  '   11111111111111111    T111111111111111  ',
  '   11111111111  1111    11111111111111121 ',
  '            11  1111  1111111111          ',
].join('\n')

const gradient = 'text-transparent bg-clip-text bg-gradient-to-b'
</script>

<template>
  <Container
    class="screen-content pointer-events-none z-0 flex flex-col items-center space-y-6 pb-16 pt-32 md:pb-16 lg:pb-16 lg:pt-48"
  >
    <div class="relative z-10 -mt-8 h-full w-full lg:-mt-16">
      <Motion
        :animate="{ y: 0, opacity: 1 }"
        :initial="{ y: -16, opacity: 0 }"
        :transition="{ easing: [0.16, 1, 0.3, 1] }"
      >
        <Heading size="hero" as="h1" class="pointer-events-none text-center" gradient="gray">
          {{ company.headline }}
        </Heading>
      </Motion>

      <AboutUsImageGrid class="pointer-events-auto relative z-10 mt-16" />
    </div>

    <template #outer>
      <PixelGrid class="!pointer-events-auto absolute z-0 hidden w-full xl:flex" :size="40" :pattern="pixelGridLg" />
      <PixelGrid
        class="!pointer-events-auto absolute z-0 hidden w-full lg:flex xl:hidden"
        :size="32"
        :pattern="pixelGridLg"
      />
      <PixelGrid
        class="!pointer-events-auto absolute z-0 hidden w-full md:flex lg:hidden"
        :size="33.4"
        :pattern="pixelGridLg"
      />
      <PixelGrid
        class="!pointer-events-auto absolute z-0 hidden w-full sm:flex md:hidden"
        :size="25.3"
        :pattern="pixelGridLg"
      />
      <PixelGrid class="!pointer-events-auto absolute z-0 flex w-full sm:hidden" :size="27.2" :pattern="pixelGridLg" />
    </template>
  </Container>
</template>
